import { Pagination } from "@mui/material";
import React, { memo, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const CustomPagination = ({ page, onChange, count, ...params }) => {
  const history = useHistory();
  const currentPageRef = useRef(page);

  useEffect(() => {
    // Create the listener
    const unlisten = history.listen(() => {
      if (currentPageRef.current != page) {
        console.log("run1");
        // onChange(undefined, page || 1);
        currentPageRef.current = page;
      }
    });

    // Cleanup function to remove listener when component unmounts
    return () => {
      unlisten();
    };
  }, [history, page, onChange]);

  console.log("currentpage", currentPageRef.current);

  useEffect(() => {
    const url = new URL(window.location);
    const pageParam = url.searchParams.get("page");
    const currentPage = pageParam ? parseInt(pageParam, 10) : 1;
    currentPageRef.current = currentPage || 1;
    if (currentPageRef.current && currentPageRef.current <= count) {
      if (currentPageRef.current != page) {
        console.log("run2", currentPageRef.current, page);
        onChange(undefined, currentPageRef.current);
      }
    } else {
      url.searchParams.set("page", page.toString());
      window.history.pushState({}, "", url);
    }
  }, [onChange]);

  const handlePageChange = (event, newPage) => {
    onChange(undefined, newPage);
    const url = new URL(window.location);
    url.searchParams.set("page", newPage.toString());
    window.history.pushState({}, "", url);
  };

  return (
    <div>
      <Pagination count={Number(count)} page={Number(page)} onChange={handlePageChange} color="primary" {...params} />
    </div>
  );
};

export default memo(CustomPagination);
